jQuery( document ).ready( function() {
	jQuery( '.representative-single-post' ).slice( 0, 6 ).show();
	if ( jQuery( '.representative-single-post' ).length > 6 ) {
		jQuery( '#loadMoreButton' ).show();
	} else {
		jQuery( '.show-more-btn' ).hide();
	}
	jQuery( '.category-btn' ).on( 'click', function() {
		const category = jQuery( this ).data( 'category' );
		jQuery( '.representative-single-post' ).hide();
		jQuery( `.representative-single-post.${ category }` ).slice( 0, 6 ).show();
		if ( jQuery( `.representative-single-post.${ category }:hidden` ).length > 0 ) {
			jQuery( '#loadMoreButton' ).data( 'current-category', category );
			jQuery( '#loadMoreButton' ).show();
			jQuery( '.show-more-btn' ).show();
		} else {
			jQuery( '.show-more-btn' ).hide();
		}
	} );
	jQuery( '#loadMoreButton' ).on( 'click', function() {
		const category = jQuery( this ).data( 'current-category' );
		if ( category ) {
			jQuery( `.representative-single-post.${ category }:hidden` ).slice( 0, 6 ).show();
		} else {
			jQuery( '.representative-single-post:hidden' ).slice( 0, 6 ).show();
		}
		if ( category ) {
			if ( jQuery( `.representative-single-post.${ category }:hidden` ).length === 0 ) {
				// If no more hidden divs, hide the "Load More" button
				jQuery( this ).hide();
				jQuery( '.show-more-btn' ).hide();
			}
		} else if ( jQuery( '.representative-single-post:hidden' ).length === 0 ) {
			jQuery( this ).hide();
			jQuery( '.show-more-btn' ).hide();
		}
	} );
	// Function to handle the "Load More" button click event for all categories
	jQuery( '.view-all-category' ).on( 'click', function() {
		jQuery( '.representative-single-post' ).slice( 0, 6 ).show();
		if ( jQuery( '.representative-single-post' ).length > 6 ) {
			jQuery( '.show-more-btn' ).show();
			jQuery( '#loadMoreButton' ).show();
		}
	} );
} );
